import { Box, Tooltip, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { Pie, PieChart, ResponsiveContainer } from "recharts";
import CommonButton from "../../../../component/Button";
import SnackBar from "../../../../component/SnackBar";
import { WeightList, WeigthScoreUpdate } from "../../../../redux/action/Weight";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../../modules/chat-bot/style";
import { CommonGrid2 } from "../../../../modules/common-components/StyledComponents";
import WeightEdit from "./components/WeightEdit";

export default function Weight() {
  const [weightList, setWeightList] = useState({
    data: [],
    loading: true,
    editData: [],
    disabled: false,
    loading: true,
    save_as_loading: false,
    save_loading: false,
  });
  const [editScenario, setEditScenario] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const breadCrumbData = [
    {
      title: "Weight",
      onClick: () => handleEditMode(),
    },
    {
      title: "Edit Weight",
      active: true,
    },
  ];

  const dropDownData = [{ name: "Custom", value: "Custom" }];
  const colorPalette = [
    "#36A41D",
    "#FF4B57",
    "#FFB300",
    "#0070F2",
    "#04AFC3",
    "#016DB8",
    "#2B4D95",
    "#25A6DF",
    "#FF6B6B",
    "#FFD93D",
    "#6BCB77",
    "#4D96FF",
    "#FFAA4C",
  ];

  const fetchListCall = async () => {
    setWeightList((prev) => ({
      ...prev,
      loading: true,
      disabled: true,
    }));
    try {
      const data = await WeightList();
      const dataWithColors = data?.data
        ?.map((item, index) => ({
          ...item,
          fields: item.fields.map((field, innerIndex) => ({
            ...field,
            fill: colorPalette[innerIndex % colorPalette.length],
          })),
        }))
        .filter((item) => item.value !== 0);
      setWeightList((prev) => ({
        ...prev,
        data: dataWithColors,
        editData: dataWithColors,
        loading: false,
        disabled: false,
      }));
    } catch (error) {
      setWeightList((prev) => ({
        ...prev,
        loading: false,
        disabled: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };
  useEffect(() => {
    fetchListCall();
  }, []);

  const renderCustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    name,
    value,
  }) => {
    if (value === 0) return null;
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 2.2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const truncate = (str, n) =>
      str.length > n ? str.slice(0, n) + "..." : str;
    return (
      <Tooltip
        arrow
        title={`${name}: ${value}`}
        style={{
          fontSize: "13px",
          fontFamily: "Inter",
          borderRadius: "8px",
        }}
      >
        <text
          x={x}
          y={y}
          fill="#475E75"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
          style={{ fontSize: "12px", fontFamily: "Inter" }}
        >
          {`${truncate(name, 10)}: ${value}%`}
        </text>
      </Tooltip>
    );
  };

  const handleEdit = () => {
    setEditScenario(true);
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleEditMode = () => {
    fetchListCall();
    setEditScenario(false);
  };

  //Edit-Scenario

  const handleSliderChange = (index, value) => {
    setWeightList((prev) => ({
      ...prev,
      data: prev.data.map((prevItem, i) => {
        return {
          ...prev.data[i],
          fields: prevItem.fields.map((field, i) => {
            if (i === index) {
              return { ...field, value: value };
            } else {
              return {
                ...field,
              };
            }
          }),
        };
      }),
    }));
  };

  const handleCancel = () => {
    handleEditMode();
  };

  const handleSetToDefault = async () => {
    setWeightList((prev) => ({
      ...prev,
      save_as_loading: true,
      disabled: true,
    }));
    let payload = {
      data: weightList.data.map((item, index) => {
        return {
          ...item,
          is_default: true,
        };
      }),
    };
    try {
      let data = await WeigthScoreUpdate(payload.data);
      await fetchListCall();
      setSnackbarState({
        open: true,
        severity: "success",
        message: data.message,
      });
      setWeightList((prev) => ({
        ...prev,
        save_as_loading: false,
        disabled: false,
      }));
    } catch (error) {
      setWeightList((prev) => ({
        ...prev,
        save_as_loading: false,
        disabled: false,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  const handleNumberChange = (value, index) => {
    setWeightList((prev) => ({
      ...prev,
      data: prev.data.map((prevItem, i) => {
        return {
          ...prev.data[i],
          fields: prevItem.fields.map((field, i) => {
            if (i === index) {
              return {
                ...field,
                value: parseInt(value) > 100 ? 100 : parseInt(value),
              };
            } else {
              return {
                ...field,
              };
            }
          }),
        };
      }),
    }));
  };

  const handleSubmit = async () => {
    let check = weightList.data[0].fields.every((item) => item.value == 0);
    if (check) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "Kindly update one of the weight values",
      });
    } else {
      setWeightList((prev) => ({
        ...prev,
        disabled: true,
        save_loading: true,
      }));
      let payload = {
        data: weightList.data.map((item, index) => {
          return {
            ...item,
            is_default: false,
          };
        }),
      };
      try {
        let data = await WeigthScoreUpdate(payload.data);
        setSnackbarState({
          open: true,
          severity: "success",
          message: data.message,
        });
        setTimeout(() => {
          setWeightList((prev) => ({
            ...prev,
            disabled: false,
            save_loading: false,
          }));
          handleEditMode();
        }, 1000);
      } catch (error) {
        setWeightList((prev) => ({
          ...prev,
          disabled: false,
          save_loading: false,
        }));
        setSnackbarState({
          open: true,
          severity: "error",
          message: error.message,
        });
      }
    }
  };

  return (
    <CustomDiv padding={"1.5rem"}>
      {!editScenario ? (
        <Fragment>
          <Typography variant="h6" color="#738496">
            The weights are the specific parameter’s priority in the scoring
            process.{" "}
          </Typography>
          <CommonGrid2 container spacing={2} marginTop={"2rem"}>
            {(weightList.loading ? [1] : weightList.data).map((item, index) => (
              <CommonGrid2
                item
                size={6}
                border="1px solid #EAECF0"
                borderRadius="10px"
                padding={"1rem"}
              >
                {weightList.loading ? (
                  <HandleSkeletion width="150px" height="50px" />
                ) : (
                  <CommonGrid2
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    container
                  >
                    <Typography variant="body5" textTransform={"capitalize"}>
                      {item.name}
                    </Typography>

                    <CommonButton
                      value={"Edit"}
                      variant="outlined"
                      color="#344054"
                      fontWeight={500}
                      padding="5px 1.5rem"
                      fontSize={"15px"}
                      border={"#D0D5DD"}
                      onClick={handleEdit}
                    />
                  </CommonGrid2>
                )}
                {weightList.loading ? (
                  <HandleSkeletion
                    width="auto"
                    margin="0.8rem 0px 0px"
                    height="100px"
                    transform="scale(1)"
                  />
                ) : (
                  <Box width="100%" display="flex" justifyContent="center">
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={item.fields}
                          dataKey="value"
                          cx="50%"
                          cy="50%"
                          innerRadius="45%"
                          outerRadius="65%"
                          label={renderCustomLabel}
                          paddingAngle={2}
                          cornerRadius={4}
                        />
                        <text
                          x="50%"
                          y="50%"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            fill: "#333",
                          }}
                        >
                          {item.overall_score}%
                        </text>
                      </PieChart>
                    </ResponsiveContainer>
                  </Box>
                )}
              </CommonGrid2>
            ))}
          </CommonGrid2>
        </Fragment>
      ) : (
        <WeightEdit
          handleEditMode={handleEditMode}
          handleSubmit={handleSubmit}
          handleNumberChange={handleNumberChange}
          handleSetToDefault={handleSetToDefault}
          handleCancel={handleCancel}
          handleSliderChange={handleSliderChange}
          dropDownData={dropDownData}
          breadCrumbData={breadCrumbData}
          weightList={weightList}
          renderCustomLabel={renderCustomLabel}
        />
      )}
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
